module.exports = __webpack_public_path__ + "img/wallet.78b60fce.png";